exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".dashboardAERTotalProjects-58ec5 .subHeader-d69c1{display:flex;justify-content:space-between;margin-top:36px;font-weight:500}.dashboardAERTotalProjects-58ec5 .subHeader-d69c1 .sign-3885c{display:flex;justify-content:space-between;width:62%}.dashboardAERTotalProjects-58ec5 .subHeader-d69c1 .sign-3885c>span{display:inline-block;width:50%;text-align:center}", ""]);

// Exports
exports.locals = {
	"dashboardAERTotalProjects": "dashboardAERTotalProjects-58ec5",
	"subHeader": "subHeader-d69c1",
	"sign": "sign-3885c"
};